﻿import { mapGetters, mapState } from 'vuex';
import { ajaxGet } from '../../utils/ajax';
import Toolkit from '../../utils/telia-toolkit.js';
import ProductsView from './ProductsView.js';
import UpgradedSpeed from './UpgradedSpeed.js';


//Only show higher speeds when boosting
//make a new list of variants with < speed

export default {
    name: 'products',
    template: '#products-template',    
    data: () => ({
        showOtherVariants: false,
        showBoosts: false,       
        fixate: false,
        fixatedAt: 0,
        openVasLessSection: false,
        openOtherOptionSection: false
    }),
    props: ['exitpageurl', 'redirecturl'],
    components: {
        'products-view' : ProductsView,
        'upgraded-speed' : UpgradedSpeed
    },
    computed:
        Object.assign(
            mapState({
                address: state => state.offeringpage.addresslookup.selectedAddress,
                allProducts: state => state.offeringpage.products.available,
                isDoneSearching: state => state.offeringpage.products.isDoneSearching,
                selectedVariantCode: state => state.offeringpage.products.selectedVariant,
                selectedNumberOfVas: state => state.offeringpage.products.selectedNumberOfVas,
                hasLookupFailure: state => state.offeringpage.addresslookup.failure,
                price: state => state.offeringpage.price,
                minimumPriceForBindingPeriod: state => state.offeringpage.minimumPriceForBindingPeriod
            }),
            mapGetters({
                otherProducts: 'otherProducts',
                otherVariants: 'otherVariants',
                selectedProduct: 'selectedProduct',
                selectedVariant: 'selectedVariant',
                selectedVAS: 'selectedVas'
            }),
            {
                numberOfVas() {
                    return this.selectedVariant.numberOfVas;
                },
                isRecommended() {
                    return this.selectedVariant.isRecommended;
                },
                isTeliaHomeFree() {
                    return this.selectedVariant.isTeliaHomeFree;
                },
                searchBegun() {
                    return this.address && Object.keys(this.address).length;
                },
                hasNoProducts() {
                    return this.isDoneSearching && !this.allProducts.length;
                },
                hasOtherProducts() {
                    return this.allProducts.length > 1;
                },
                hasOtherVariants() {
                    const product = this.selectedProduct;

                    return product && product.variants.length > 1;
                }, 
                availableBoosts() {
                    let boosts = [];
                    if(!this.otherVariants || !this.selectedVariant) return boosts;
                    for (var i = 0; i < this.otherVariants.length; i++) {
                        if(this.selectedVariant.speedDown < this.otherVariants[i].speedDown)
                            if(this.selectedVariant.numberOfVas === this.otherVariants[i].numberOfVas)
                                boosts.push(this.otherVariants[i]);
                    }
                    return boosts;
                },
                isBoostAvailable() {
                    if(!this.availableBoosts) return false;
                    else return this.availableBoosts.length > 0
                },
                hasOtherTechnologies() {
                    return this.allProducts.length >= 1;
                },
                otherProductsIsAvailable(){
                    return this.otherProducts.length > 0;
                },
                hasPickedVas() {
                    if (!this.selectedVAS) return false;
                    return this.selectedVAS.length > 0;
                },
                iconUrl() {
                  if (this.selectedProduct.code == 'LLF') return '/UI/ECommerce/images/ico-fiber.png';
                  if (this.selectedProduct.code == 'LLN') return '/UI/ECommerce/images/ico-coax.png';
                  if (this.selectedProduct.code == 'LLD') return '/UI/ECommerce/images/ico-dsl.png';
                  if (this.selectedProduct.code == 'MBB2') return '/UI/ECommerce/images/ico-mbb.png';
                   

                    return '';
                },
                speed() {
                    if (this.selectedProduct.code == 'MBB2') return this.selectedVariant.speedDown;
                    return this.selectedVariant.speedDown + "/" + this.selectedVariant.speedUp;
                },
                vasLessProductsAvailable() {
                    if (this.allProducts.length) {                       
                        for (let i = 0; i < this.allProducts.length; i++) {
                            if (this.allProducts[i].variants.filter(variant => variant.numberOfVas == 0).length > 0) {
                                return true;                                
                            }
                        }
                    }                    
                    return false;
                }
            }
        ),
    methods: {
            showVaslessOfferings() {
                this.openVasLessSection = !this.openVasLessSection;
                return this.openVasLessSection;
            },
            showOtherOptions() {
                this.openOtherOptionSection = !this.openOtherOptionSection;
                return this.openOtherOptionSection;
            },
            selectVariant(installationFeeId, activationFeeId, productCode, variantCode, selectedNumberOfVas,vendor) {
                this.$store.dispatch('selectVariant', { installationFeeId: installationFeeId, activationFeeId: activationFeeId, productCode: productCode, variantCode: variantCode, numberOfVas: selectedNumberOfVas, vendor: vendor });
            },
            isSelected(code) {
                return {
                    'selected': code === this.selectedVariantCode
                };
            },
            toggleVariantsModal(msg) {
                if(this.showOtherVariants) {
                    this.showOtherVariants = false;
                    this.enableScrolling();
                }
                else {
                    this.showOtherVariants = true;
                    Toolkit.loadToolkit();
                    this.preventScrolling();
                }
            },
            toggleBoostModal(msg) {
                if(this.showBoosts) {
                    this.showBoosts = false;
                    this.enableScrolling();
                }
                else {
                    this.showBoosts = true;
                    this.preventScrolling();
                }
            },
            enableScrolling() {
                var x = document.getElementsByTagName("BODY")[0];
                x.className = x.className.replace(/\bts-scroll-stop\b/,'');
            },
            preventScrolling() {
                var x = document.getElementsByTagName("BODY")[0];
                x.className += " ts-scroll-stop";
            }
    },
        mounted: function (){
            //Toolkit.loadToolkit();
            document.addEventListener("keydown", (e) => {
                if (e.keyCode === 27) {
                    this.showBoosts = false;
                    this.showOtherVariants = false;
                    this.enableScrolling();
                }
            });

            document.addEventListener('click', (e) => {
                e = e || window.event;
                var target = e.target || e.srcElement;
                if(target.classList && target.classList.length > 0 && target.classList[0] === 'row') {
                    this.showBoosts = false;
                    this.enableScrolling();
                }
                else if (target.classList && target.classList.length > 0 && target.classList[0] === 'ts-modal') {
                    this.showOtherVariants = false;
                    this.enableScrolling();
                }
            }, false);
          
        }
}
